module.exports = __webpack_public_path__ + "src/assets/games/17/102.jpg";